import { render, staticRenderFns } from "./editOrder.vue?vue&type=template&id=2544c4b2&scoped=true&"
import script from "./editOrder.vue?vue&type=script&lang=js&"
export * from "./editOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2544c4b2",
  null
  
)

export default component.exports